module.exports = __webpack_public_path__ + "static/img/xi_3.fad1201.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_3.jpg
// module id = /p2Q
// module chunks = 1